import React from 'react'
import styled from 'styled-components';
import { BoxItem, BoxItemEmpty} from '../common/styled/BoxItem'
import ViewBtn from '../common/ViewBtn'

const Item = styled(BoxItem)`
  .img-bg {
    width: 100%;
    height: 280px;
    background-color: #eee;
    border-top-left-radius: 13px;
    border-top-right-radius: 13px;
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
    }
  }
  .avatar {
    display: flex;
    justify-content: center;
    position: relative;
    margin-top: -63px;
    img {
      width: 126px;
      height: 126px;
      border-radius: 50%;
      background-color: #eee;
      border: 4px solid #FFFFFF;
      object-fit: cover;
    }
  }
  .userinfo {
    text-align: center;
    .name {
      color: #3D6DE5;
      font-size: 30px;
      font-weight: 500;
    }
    .more {
      color: #999999;
      font-size: 18px;
    }
  }
  .iteminfo {
    margin-top: 25px;
    text-align: center;
    padding: 0 20px;
    .title {
      color: #2A2D35;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      height: 70px;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .desc {
      color: #666666;
      height: 66px;
      text-overflow: ellipsis;
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
  @media (max-width: 768px) {
    height: auto;
    .img-bg {
      height: 200px;
    }
    .iteminfo {
      .title, .desc {
        height: auto;
        line-clamp: 10;
        -webkit-line-clamp: 10;
      }
    }
  }
  .bottom {
    padding: 20px 30px;
    margin-bottom: 20px;
    height: 92px;
    display: flex;
    justify-content: space-between;
    .share {
      width: 68px;
      height: 100%;
      border-radius: 5px;
      border: 1px solid #23A020;
      cursor: pointer;
      display: flex;
      justify-content: center;
      align-items: center;
      .icon {
        width: 22px;
      }
    }
    .view-btn {
      width: 100%;
    }
  }
`;

export default function SelectionItem(props) {
  return (
    <>
      {!props.empty &&
      <Item>
        <div className="img-bg">
          <img src={props.bgurl} alt=""/>
        </div>
        <div className="avatar">
          <img src={props.avatar} alt=""/>
        </div>
        <div className="userinfo">
          <div className="name">{props.name}</div>
          {/* <div className="more">{props.more} grants</div> */}
        </div>
        <div className="iteminfo">
          <h3 className="h3 title">{props.title}</h3>
          <div className="desc">{props.desc}</div>
        </div>
        <div className="bottom">
          {/* <div className="share">
            <svg t="1620478491437" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="29072" width="32" height="32"><path d="M64.9 791.3c0-37.7-8.6-186.7 115.7-304.9 83.6-79.5 208.7-93.3 358.4-99.6V188.6c0-19.1 16.3-34.5 36.5-34.5 9.1 0 17.8 3.2 24.5 9l347.4 298c14.9 12.8 16.1 34.6 2.5 48.7-0.7 0.7-1.5 1.4-2.3 2.1L600.3 816.2c-14.8 13-37.9 12.1-51.6-1.9-6.3-6.4-9.7-14.8-9.7-23.5v-197c-95 2.5-162.7 8.2-224.2 26.7-88.6 26.6-157 102.2-205.3 226.8-5.3 13.6-18.9 22.6-34.3 22.6H64.7c0-22.7 0.2-58.6 0.2-78.6z" p-id="29073" fill="#23A020"></path></svg>
          </div> */}
          <div className="view-btn">
            <ViewBtn href={props.page}></ViewBtn>
          </div>
        </div>
      </Item>
      }
      {props.empty && <BoxItemEmpty>stay tuned</BoxItemEmpty> }
    </>
  )
}